'use strict';

var { reject } = require('underscore'),
    isSectionEmpty = require('./isSectionEmpty'),
    cloneDeep = require('lodash/lang/cloneDeep');

function getRefinedStamp(stamp) {
  if (!stamp) {
    return null;
  }

  stamp = cloneDeep(stamp);
  stamp.content = {
    sections: reject(
      stamp.content.sections,
      section => isSectionEmpty(section, true)
    )
  };

  return stamp;
}

module.exports = getRefinedStamp;


/** WEBPACK FOOTER **
 ** ./utils/getRefinedStamp.js
 **/